import React from 'react';
import { useTranslation } from 'react-i18next';
import logoWhite from '../assets/smart_todo_branco.png';
import './Footer.css';

const APP_URL = process.env.REACT_APP_APP_URL || 'https://app.libbenagents.com';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src={logoWhite} alt="Libben Agents" className="footer-logo" />
          <p className="footer-tagline">{t('footer.tagline')}</p>
        </div>

        <div className="footer-col">
          <h4>{t('footer.product')}</h4>
          <a href="/#features">{t('footer.links.features')}</a>
          <a href="/saude">{t('footer.links.health', { defaultValue: 'Saúde' })}</a>
          <a href="/agentes">{t('footer.links.agents', { defaultValue: 'Agentes' })}</a>
          <a href="/precos">{t('footer.links.pricing')}</a>
          <a href="/#integrations">{t('footer.links.integrations')}</a>
          <a href="/blog">{t('footer.links.blog')}</a>
        </div>

        <div className="footer-col">
          <h4>{t('footer.legal')}</h4>
          <a href="/terms">{t('footer.links.terms')}</a>
          <a href="/privacy">{t('footer.links.privacy')}</a>
          <a href="/cookies">{t('footer.links.cookies')}</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('footer.copyright')}</p>
        <a href={`${APP_URL}/login`} className="footer-login">
          {t('nav.login')} →
        </a>
      </div>
    </footer>
  );
}
